<template>
	<sf-data-table
		ref="partPopupTable"
		index
		:columns="columns"
		:rows="resultPopupCommList"
		:stripe="false"
		:selection="false"
		height="520px"
		fit="fit"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PartCku/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					// 품번
					label: this.getMessage_('QWCC000956'),
					prop: 'partNo',
					minWidth: '150px',
					sortable: false,
					highlight: true
				},
				{
					// 대구분코드
					label: this.getMessage_('QWCC001836'),
					prop: 'ckuPrvsCd',
					minWidth: '100px',
					sortable: false,
					highlight: false
				},
				{
					// 대구분코드명
					label: this.getMessage_('QWCC001837'),
					prop: 'ckuPrvsNm',
					minWidth: '150px',
					sortable: false,
					highlight: false
				},
				{
					// 소구분코드
					label: this.getMessage_('QWCC001838'),
					prop: 'prvsClCd',
					minWidth: '100px',
					sortable: false,
					highlight: false
				},
				{
					// 소구분코드명
					label: this.getMessage_('QWCC001839'),
					prop: 'prvsClNm',
					minWidth: '150px',
					sortable: false,
					highlight: false
				},
				{
					// 검사방법코드
					label: this.getMessage_('QWCC001840'),
					prop: 'ckuWayCd',
					minWidth: '100px',
					sortable: false,
					highlight: false
				},
				{
					// 검사방법코드명
					label: this.getMessage_('QWCC001841'),
					prop: 'ckuWayNm',
					minWidth: '150px',
					sortable: false,
					highlight: false
				},
				{
					// 콤보여부
					label: this.getMessage_('QWCC001842'),
					prop: 'comboYn',
					minWidth: '100px',
					sortable: false,
					highlight: false
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods
	}
};
</script>

<style></style>
